/**
 * Convert array of week-year strings to relative display format
 * @param weekYearArray - Array of week-year strings (e.g., ['2518', '2519', ..., '2529'])
 * @returns Array of display formats like ['W12 \'25', 'W11 \'25', ..., 'W1 \'25']
 */
export const convertWeekYearsToDisplay = (weekYearArray: string[]): string[] => {
    // Convert string array to numbers for calculation
    const weekNumbers = weekYearArray.map(week => parseInt(week, 10));

    // Find the maximum week number (most recent)
    const maxWeek = Math.max(...weekNumbers);

    // Convert each week to display format
    return weekYearArray.map(weekStr => {
        const weekNumber = parseInt(weekStr, 10);

        // Calculate relative week position (1 = most recent, 12 = oldest)
        const relativeWeek = maxWeek - weekNumber + 1;

        // Extract year from week number (last 2 digits of first part)
        const year = Math.floor(weekNumber / 100) % 100;

        // Format as "W{relative_week} '{year}"
        return `W${relativeWeek} '${year.toString().padStart(2, '0')}`;
    });
};

/**
 * Helper function to convert week numbers to relative display format
 * @param weekNumber - The week number to convert (e.g., 2518)
 * @param allWeeks - Array of all 12 week numbers for context
 * @returns Display format like "W12 '25"
 */
export const getWeekDisplay = (weekNumber: string, allWeeks: string[]): string => {
    // Convert week numbers to numbers
    const weekNum = parseInt(weekNumber, 10);
    const allWeekNums = allWeeks.map(w => parseInt(w, 10));

    // Find the maximum week number (most recent)
    const maxWeek = Math.max(...allWeekNums);

    // Calculate relative week position (1 = most recent, 12 = oldest)
    const relativeWeek = maxWeek - weekNum + 1;

    // Extract year from week number (last 2 digits of first part)
    const year = Math.floor(weekNum / 100) % 100;

    // Format as "W{relative_week} '{year}"
    return `W${relativeWeek} '${year.toString().padStart(2, '0')}`;
};